import React from 'react';
import './App.css';
import Narvbar from './components/Narvbar';
import Descritpion from './components/Descritpion';
import Features from './components/Features';
import Works from './components/Works';
import Partners from './components/Partners';
import Objectives from './components/Objectives';
import "animate.css/animate.min.css";
import WhatsApp from './components/Whatsapp';
import Contact from './components/contact';
import Footer from './components/Footer';
import Popup from './components/Popup';
import About from './components/About';
import Clients from './components/Clients'

function App() {

  const [showPopup, setShowPopup] = React.useState(false);

  if (showPopup) {
    document.body.style.overflowY = 'hidden';
  } else {
    document.body.style.overflowY = 'unset';
  }


  return (
    <div className="App" style={{ msOverflowY: 'hidden' }}>
      <Narvbar showPopup={showPopup} setShowPopup={setShowPopup} />
      <div className='main-section-wrapper' style={{ msOverflowY: 'hidden' }}>
        <section className='main-section' style={{ msOverflowY: 'hidden' }}>
          <Popup showPopup={showPopup} setShowPopup={setShowPopup} />
          
          <Descritpion />
          <div className='main-section-quadrants'>
            <div className='left-quadrant'>
            </div>
            <div className='right-quadrant'>
            </div>
          </div>
        </section>
      </div>
      <Features />
      <About/>
      {/* <Works /> */}
      <Clients/>
      {/* <Partners /> */}
      <Objectives />
      <WhatsApp />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
